// uiSlice.js
import { createSlice } from "@reduxjs/toolkit";

const uiSlice = createSlice({
  name: "ui",
  initialState: {
    showConfirmationPopup: false,
    confirmationData: null,
    confirmationMode: null, // 'new' | 'complete'
  },
  reducers: {
    triggerConfirmationPopup: (state, action) => {
      state.showConfirmationPopup = true;
      // state.confirmationData = action.payload.data;
      // state.confirmationMode = action.payload.mode;
      state.confirmationMode = action.payload?.mode || 'info';
      state.confirmationData = action.payload?.data || null;
    },
    closeConfirmationPopup: (state) => {
      state.showConfirmationPopup = false;
      state.confirmationData = null;
      state.confirmationMode = null;
    },
  },
});


export const { triggerConfirmationPopup, closeConfirmationPopup } = uiSlice.actions;
export default uiSlice.reducer;
